import { useEffect, useState } from "react";
import tw from "twin.macro";
import { likeCount, wishCount } from "../api/ProducDetailsApi";
import {
  productLikeCount,
  productWishCount,
  deleteCustomerLike,
  createCustomerLike,
  createCustomerWish,
  deleteCustomerWish,
} from "api/Like&WishCountApi";
import { useLocation, Link } from "react-router-dom";
import Noimg from "../images/no_img.jpg";
import { getAllMetalStandards, getAllTax, getProduct, getProductOrderItemPage } from "api/ProductApi";
import { filterFormatFromDate, filterFormatToDate, getCurrentTimeConfig, INITIAL_SELECT_VALUE, SectionLabel, YEAR_WISE_FORMAT } from "utility/Constant";
import { getBranchId, getCustomerData, getCustomerId } from "../utility/HeaderConfig.js";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import toast, { Toaster } from "react-hot-toast";
// import BookAppointmentButton from "components/BookAppointmentButton";
import ProductPriceDetails from "components/ProductPriceDetails";
import { useCartContext } from "context/UseCartContext";
import RelatedProduct from "components/RelatedProduct";
import Magnifier from "../components/Magnifier";
import { Carousel } from "react-responsive-carousel";
// import { dayClose } from "api/NewSchemeApi";
import moment from "moment";
// import ProductType from "components/ProductType";
import {
  Language, EnquierySource, EnquieryStatus, EmplyeeId,
  EnquieryTypeId, createEnquiry, getEnquiryByPage,
} from "api/BookAnAppointmentApi.js";
import { currentDateToUtcDate } from "utility/Constant";
import { createProductOrder, getAllFinancialYear, getAllPaymentMode, getAllSection } from "api/CheckOutApi";
import { PurityApi } from "api/PurityApi";
import { getOrderStatusId } from "utility/UtilFunction";

const StyledDiv = tw.div`font-display overflow-hidden md:overflow-visible`;

const red = "#6b5330";

const tableCellStyle = {
  fontSize: 12, color: red, padding: "10px 16px",
  borderBottom: "1px solid #f7f5f2",
};

function Pill({ children }) {
  return (
    <span style={{
      display: "inline-flex", alignItems: "center",
      padding: "3px 12px", borderRadius: "var(--radius-pill)",
      background: "var(--gold-100)", border: `1px solid ${"var(--gold-200)"}`,
      fontSize: 11, fontWeight: 700, letterSpacing: ".07em", color: "var(--gold-400)",
    }}>{children}</span>
  );
}

function InfoRow({ label, value, purity }) {
  return (
    <div style={{
      display: "flex", alignItems: "center", gap: 12,
      padding: "11px 0", borderBottom: `1px solid ${"var(--gold-100)"}`,
    }}>
      <span style={{
        fontSize: 11, fontWeight: 600, letterSpacing: ".07em",
        textTransform: "uppercase", color: "var(--gold-400)", minWidth: 130,
      }}>{label}</span>
      <span style={{ fontSize: 14, color: "var(--red-900)", fontWeight: 500, flex: 1 }}>{value}</span>
      {purity}
    </div>
  );
}

function StatChip({ icon, count, label, onClick, active }) {
  return (
    <div
      onClick={onClick}
      style={{
        display: "flex",
        alignItems: "center",
        gap: 6,
        padding: "6px 14px",
        borderRadius: "var(--radius-pill)",
        // background: active ? "#fce7f3" : "var(--gold-50)",
        fontSize: 12,
        color: active ? "#e11d48" : "var(--gold-500)",
        cursor: "pointer",
        transition: "0.2s",
      }}
    >
      {icon}
      <span style={{ fontWeight: 600 }}>{count}</span>
      <span>{label}</span>
    </div>
  );
}

function AccordionPanel({ title, open, onToggle, children }) {
  return (
    <div style={{
      border: `1px solid ${"var(--gold-200)"}`, borderRadius: "var(--radius-md)",
      overflow: "hidden", marginBottom: 10,
    }}>
      <button
        onClick={onToggle}
        style={{
          width: "100%", display: "flex", justifyContent: "space-between",
          alignItems: "center", padding: "13px 18px",
          background: "var(--surface-warm)", border: "none", cursor: "pointer",
          fontSize: 13, fontWeight: 600, color: "var(--red-700)",
          transition: "background .18s",
        }}
      >
        <span style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "var(--gold-400)", flexShrink: 0 }} />
          {title}
        </span>
        <svg
          width="14" height="14" viewBox="0 0 24 24" fill="none"
          stroke={"var(--gold-400)"} strokeWidth="2.5"
          style={{ transform: open ? "rotate(180deg)" : "none", transition: "transform .22s" }}
        >
          <polyline points="6 9 12 15 18 9" />
        </svg>
      </button>
      {open && (
        <div style={{ borderTop: `1px solid ${"var(--gold-100)"}`, padding: "16px 18px", background: "#ffffff" }}>
          {children}
        </div>
      )}
    </div>
  );
}

function WeightCard({ label, value }) {
  return (
    <div style={{
      display: "flex", flexDirection: "column", alignItems: "center", gap: 4, padding: "14px 10px",
      background: 'var(--gold-50)', borderRadius: "var(--radius-md)", border: `1px solid ${"var(--gold-100)"}`,
    }}>
      <span style={{ fontSize: 10, fontWeight: 700, letterSpacing: ".1em", textTransform: "uppercase", color: "var(--red-400)" }}>{label}</span>
      <span style={{ fontSize: 15, fontWeight: 400, color: "var(--red-900)", fontFamily: "'InterSemiBold','NotoSansDevanagariSemiBold','Helvetica Neue',Helvetica,Arial,sans-serif" }}>{value}</span>
      <span style={{ fontSize: 10, color: "var(--red-400)" }}>gms</span>
    </div>
  );
}

function ActionBtn({ label, icon, onClick, variant = "primary", disabled = false }) {
  const [hov, setHov] = useState(false);
  const styles = {
    primary: {
      bg:     disabled ? "#c7c7cc" : hov ? "var(--gold-400)"  : "var(--red-900)",
      color:  "#fff",
      border: "none",
    },
    secondary: {
      bg:    disabled ? "#e5e5ea" : hov ? "var(--red-100)"  : "#ffffff",
      color: disabled ? "#9e9e9e" : "var(--red-900)",
      border: `1px solid ${"var(--gold-200)"}`,
    },
    ghost: {
      bg:    disabled ? "#e5e5ea" : hov ? "var(--gold-100)" : "var(--surface-cream)",
      color: disabled ? "#9e9e9e" : "var(--gold-400)",
      border: `1.5px solid ${"var(--gold-100)"}`,
    },
  }[variant];

  return (
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      onMouseEnter={() => { if (!disabled) setHov(true); }}
      onMouseLeave={() => setHov(false)}
      style={{
        display: "flex", alignItems: "center", justifyContent: "center", gap: 8,
        width: "100%", padding: "14px 20px",
        background: styles.bg, color: styles.color,
        fontSize: 12, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase",
        border: styles.border, borderRadius: "var(--radius-md)",
        cursor: disabled ? "not-allowed" : "pointer",
        transition: "background .2s, color .2s",
        boxShadow: variant === "primary" && hov && !disabled ? "var(--shadow-md)" : "none",
        opacity: disabled ? 0.7 : 1,
      }}
    >
      {icon} {disabled ? "Please wait…" : label}
    </button>
  );
}

export default ({ configImages }) => {
  const [Details, setDetails] = useState([]);
  const [otherCharge, setOtherCharge] = useState([]);
  const [productId, setProductId] = useState("");         //eslint-disable-line
  const [additionalCharge, setAdditionalCharge] = useState([]);
  const [isLoader, setLoader] = useState(false);
  const [Img, setImg] = useState([]);
  const [Spec, setSpec] = useState([]);
  const [LikeCount, setLikeCount] = useState("");
  const [WishCount, setWishCount] = useState("");
  const [banner, setBanner] = useState([]);        //eslint-disable-line
  const [currentImg, setCurrentImg] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isActiveToggle, setIsActiveToggle] = useState(false);
  const [secMetalDetail, setSecMetalDetail] = useState([]);
  const [liked, setLiked] = useState(false);
  const [wished, setWished] = useState(false);
  const [goldPurityId, setGoldPurityId] = useState("");
  const [silverPurityId, setSilverPurityId] = useState("");
  const [financialyear, setFinancialYear] = useState("");
  const [selectedPayment, setSelectedPayment] = useState(INITIAL_SELECT_VALUE);
  const [selectedFloor, setSelectedFloor] = useState(INITIAL_SELECT_VALUE);
  const [orderStatus, setOrderStatus] = useState(INITIAL_SELECT_VALUE);
  const [selectedSection, setSelectedSection] = useState(INITIAL_SELECT_VALUE);
  const [selectedTax, setSelectedTax] = useState(INITIAL_SELECT_VALUE);
  const [isOrderLoading, setIsOrderLoading] = useState(false);
  const [selectedSGTax, setSelectedSGTax] = useState(INITIAL_SELECT_VALUE);
  const [isEnquiryLoading, setIsEnquiryLoading] = useState(false);


  // Book Enquiry — state mirrors BookAnAppointment
  const [EnquieryId, setEnquieryId] = useState([]);
  const [EnquieryStatusId, setEnquieryStatusId] = useState("");
  const [EmployeeId, setEmployeeId] = useState("");
  const [EnquieryTypeid, setEnquieryTypeid] = useState("");
  const [enqLanguageId, setEnqLanguageId] = useState("");

  useEffect(() => {
    EnquierySourceId();
    EnquierySourceStatus();
    EnquieryEmployeeId();
    EnquieryType();
    SelectEnqLanguage();
    // eslint-disable-next-line
  }, []);

    const getmetalStandardList = () => {
    let updatedDate = moment().format(YEAR_WISE_FORMAT);
    const filterData = {
      productTypeId:Details.productTypeId,
      beforeCreatedAt:filterFormatToDate(updatedDate)
    }
    const responseData = getAllMetalStandards(filterData);
    responseData.then(
      (data) => {
        const metalStandard = []
        data.response.forEach((item) => {
          metalStandard.push({
            value:item.id,
            label:item.label
          })
        })
      }
    )
    return responseData
  }



  const getPaymentData = () => {
    const responseData = getAllPaymentMode();
    responseData.then((data) => {
      const paymentModeList = [];
      data.response.forEach((item) => {
        if (item.name.toLowerCase() === "cash") {
          paymentModeList.push({
            value: item.id,
            label: item.name,
          });
        } 
      });
      setSelectedPayment(paymentModeList);
    });
    return responseData
  };

  const getProductRate = async () => {
    let fromDate = moment().startOf("day").format("YYYY-MM-DD HH:mm:ss");
    let toDate = moment().endOf("day").format("YYYY-MM-DD HH:mm:ss");
    let goldPurityData = "";
    let silverPurityData = "";
    const filterData = {
      branch: getBranchId(),
      createdAtFrom: filterFormatFromDate(fromDate),
      createdAtTo: filterFormatToDate(toDate),
    };
    const todayMetalRate = await PurityApi(filterData);
    todayMetalRate.response.forEach((item) => {
      if (item.metaProdTypeName === "Gold" && item.purity === "22K - 91.6%") {
        goldPurityData = item.purityId;
      }
      if (item.metaProdTypeName === "Silver" && item.purity === "90%") {
        silverPurityData = item.purityId;
      }
    });
    setGoldPurityId(goldPurityData);
    setSilverPurityId(silverPurityData);
  };

  const getFinacialYearData = () => {
    const filterData = {
      isDefault: 1,
    };
    const responseData = getAllFinancialYear(filterData);
    responseData.then((data) => {
      setFinancialYear(data[0]?.id);
    });
    return responseData
  };

  const getSectionDetails = async() => {
    const filterData = {sectionName:Details.sectionName}
    const responseData = await getAllSection(filterData);
    const sectionList = [];
    const floorList = [];
    if (responseData && responseData.response) {
    responseData.response.forEach((item) => {
      sectionList.push({
        value: item.id,
        label: item.sectionName,
      });
      floorList.push({
        value: item.floorId,
        label: item.floorNumber,
      });
    });
    setSelectedSection(sectionList);
    setSelectedFloor(floorList);
  }
    return responseData
  };


 const getProductOrderStatus = async () => {
    let OrderDetails = "";
    const responseData = await getOrderStatusId();
    responseData.response.forEach((item) => {
      if (item.orderStatusName.toLowerCase() === "confirmed") {
        OrderDetails = item;
      }
    });
    setOrderStatus(OrderDetails);
    return responseData
  };

  const EnquierySourceId = () => {
    EnquierySource().then((d) => {
      const found = d.response.filter((i) => i.name === "ECOMM_WEB");
      setEnquieryId(found);
    });
  };

  const EnquierySourceStatus = () => {
    EnquieryStatus().then((d) => {
      const hot = (d.response || []).find((i) => i.name?.toLowerCase() === "hot");
      setEnquieryStatusId(hot ? hot.id : "");
    });
  };

  const EnquieryEmployeeId = () => {
    EmplyeeId(JSON.stringify({ name: "ONLINEPAYMENT" })).then((d) => {
      setEmployeeId(d.response?.find((item) => (item.name === "ONLINEPAYMENT" || item.name === "Onlinepayment"))?.id);
    });
  };

  const EnquieryType = () => {
    EnquieryTypeId().then((d) => {
      const sales = (d.response || []).find((i) => i.name?.toLowerCase() === "sales");
      setEnquieryTypeid(sales ? sales.id : "");
    });
  };

  const SelectEnqLanguage = () => {
    Language().then((d) => {
      const list = d.response || [];
      const tamil = list.find((l) => l.languageName?.toLowerCase() === "tamil");
      setEnqLanguageId(tamil ? tamil.id : list[0]?.id || "");
    });
  };

  const postEnquiryRequest = () => {
    const now = moment().format("YYYY-MM-DD HH:mm:ss");
    const end = moment().add(30, "minutes").format("YYYY-MM-DD HH:mm:ss");
    const payload = {
      customer: { id: getCustomerId() },
      enquirySourceId: EnquieryId[0]?.id,
      enquiryStatusId: EnquieryStatusId,
      enqGeneratedById: EmployeeId,
      productTypeId:Details.productTypeId,
      enquiredProductWeight:Details.goldGross,
      productId: Details.id || null,
      prevFollowUpDate: currentDateToUtcDate(now),
      nextFollowUpDate: currentDateToUtcDate(end),
      enquiryTypeId: EnquieryTypeid,
      reqDetails: `Book Enquiry for ${Details.title}(${Details.skv} - Available at ${Details.branchName})`,
      branchId: getBranchId(),
      languageId: enqLanguageId || null,
    }
    createEnquiry(JSON.stringify(payload))
      .then(() => {
        toast.success("Enquiry submitted successfully!", { duration: 2500, position: "top-right" });
        setIsEnquiryLoading(false);
      })
      .catch(() => {
        toast.error("Appointment already booked for this product!", { duration: 2000, position: "top-right" });
        setIsEnquiryLoading(false);
      });
  };

  const handleBookEnquiry = () => {
    if (!getCustomerId()) {
      dispatch({ type: "MODAL", payload: "login" });
      return;
    }
    setIsEnquiryLoading(true);
    getEnquiryByPage(JSON.stringify({
      customerEntity: getCustomerId(),
      branchDetailsEntity: getBranchId(),
      productEntity: Details.id,
    })).then((res) => {
      if (res.response.content.length > 0) {
        toast.error("Enquiry already exists for this product!", { duration: 2000, position: "top-right" });
        setIsEnquiryLoading(false);
      } else {
        postEnquiryRequest();
      }
    }).catch(() => postEnquiryRequest());
  };  

  const getProductOrderData = () => {
    const filterData ={
      branchDetailsEntity:getBranchId(),
      customerId:getCustomerId(),
      prodAdvanceItemTagNum:Details.productCode
    }
    const response = getProductOrderItemPage(filterData)
    response.then(
      (data) => {
        console.log('prd response:',data.response)
      }
    )
    return response
  }

   const handleBookProductOrder = async() => {
    if (!getCustomerId()) {
      toast.error("Please sign in to Book Your Order", { position: "top-right" });
      dispatch({ type: "MODAL", payload: 'login' });
      return;
    }
    const productOrderResponse = await getProductOrderData()
    if (productOrderResponse && productOrderResponse.response.content?.length > 0) {
      toast.error("Order has been already Booked", { position: "top-right" });
      return;
    }
    setIsOrderLoading(true);
    const sectionResponse = await getSectionDetails();
    let sectionId = selectedSection.value;
    let floorId = selectedFloor.value;
    if (sectionResponse && sectionResponse.response && sectionResponse.response.length > 0) {
    sectionId = sectionResponse.response[0].id;
    floorId = sectionResponse.response[0].floorId;
  } 
    let metalStandardId = '';
    const metalResponse = await getmetalStandardList()
    if (metalResponse && metalResponse.response && metalResponse.response.length > 0) {
      metalStandardId = metalResponse.response[0].id
    }
    const customerData = JSON.parse(getCustomerData())
    const v1Date = moment().format(YEAR_WISE_FORMAT);
    const v2Date = `${v1Date} ${getCurrentTimeConfig()}`;
    const date = currentDateToUtcDate(v2Date);
    const expDate = moment().add(30, "days").format(YEAR_WISE_FORMAT);
    const exV3Date = `${expDate} ${getCurrentTimeConfig()}`;
    const expectedDateInfo = currentDateToUtcDate(exV3Date);
    const statusHistoryInfo = [
      {
        status: "Confirmed",
        updated_date: date,
        updated_by: "",
        updatedByName: "Select",
        metalRate:true
      },
    ];
    const paymentModeInfo = [
      {
        tax: [
          { expectedAmt: Details.total - (Details.saleTaxList[0].amount + Details.saleTaxList[1].amount) },
          {
            value: selectedTax[0].value,
            label: selectedTax[0].label,
            name: selectedTax[0].name,
            percent: selectedTax[0].percent,
            taxAmt: Details.saleTaxList[0].amount,
          },
          {
            value: selectedSGTax[0].value,
            label: selectedSGTax[0].label,
            name: selectedSGTax[0].name,
            percent: selectedSGTax[0].percent,
            taxAmt: Details.saleTaxList[1].amount,
          },
        ],
        name: selectedPayment[0]?.label,
        remarks: "RECEIVED",
        value: 0,
        payableAmount: 0,
        paymentMode: selectedPayment[0].value,
        bankAccountId: null,
        paymentCash: true,
        expectedAmt: Details.total,
        paymentMetal: false,
        customerPaymentId: null,
        customerPaymentName: null,
        processingFeeInPercent: 0,
        processingFeeTaxInPercent: 0,
        processingFeeInValue: 0,
        processingFeeTaxInValue: 0,
      },
    ];
    const productOrderReceiptData = [
      {
        acceptedAmount: Details.total,
        balanceAmount: 0,
        branch: getBranchId(),
        customerId: customerData.id,
        expectedAmount: Details.total,
        paidAmount: 0,
        paidDate: date,
        paymentMode: JSON.stringify(paymentModeInfo),
        priceRateType: "Current Rate",
        status: "Confirmed",
        statusHistory: JSON.stringify(statusHistoryInfo),
      },
    ];
    const productOrderItemList = [
      {
        branchId: Details.branchId,
        deleteProdOrderItemId: "",
        description: "",
        expectedAmt: Details.total,
        expectedDate: expectedDateInfo,
        fbScore: 0,
        financialYearMetadataId: financialyear,
        floorId: floorId,
        huId: "",
        mcType: Details.mcType,
        mcUnit: "pergm",
        metaProdTypeId: Details.productTypeId,
        metaPurityId: Details.productTypeName.toLowerCase() === 'gold' ? goldPurityId : silverPurityId,
        metaSpecificationId: null,
        metaSpecificationName: "Select",
        metalRate:Details.todayRate,
        netOrderWastage:Details.netWastage,
        orderGrossWeight:Details.productTypeName.toLowerCase() === 'gold' ? Details.goldGross : Details.silverGross,
        orderLessWeight: Details.productTypeName.toLowerCase() === 'gold' ? Details.goldLess : Details.silverLess,
        orderMCValue: Details.mcValue,
        orderNetMc: Details.netMc,
        orderNetWeight: Details.productTypeName.toLowerCase() === 'gold' ? Details.goldNet : Details.silverNet,
        orderOtherCharges:Details.otherCharges,
        orderScValue: 0,
        orderStatusId: null,
        orderType: "CUSTOMIZATION",
        orderWastageValue: Details.wastageValue,
        piece: Details.quantity,
        priority: "Medium",
        productAdvanceItemImageList:null,
        productCategoryId: Details.categoryId,
        productId: Details.id,
        productName: Details.productName,
        productStandardMetadataId: metalStandardId,
        productSubcategoryId: Details.subCategoryId,
        receivedBy:EmployeeId,
        receivedDate: date,
        remark: `Tag Number:${Details.productCode},Gross Wt:${Details.productTypeName.toLowerCase() === 'gold' ? Details.goldGross : Details.silverGross},Less Wt: ${Details.productTypeName.toLowerCase() === 'gold' ? Details.goldLess : Details.silverLess}, Net Wt: ${Details.productTypeName.toLowerCase() === 'gold' ? Details.goldNet : Details.silverNet}, ProductName:${Details.productName}`,
        scType: "rs",
        sectionDetailsId: sectionId,
        statusId: orderStatus.id,
        totalOrderScValue: 0,
        vendorId: null,
        wastageType: Details.wastageType
      },
    ];
    
    const productOrderDetails = JSON.stringify({
      branch: getBranchId(),
      custPayableAmount: "0",
      custPrevCredit: 0,
      custPrevDebit: 0,
      customer: customerData.id,
      customerCreditDetails: null,
      customerCurrentCredit: Details.total,
      customerCurrentDebit: 0,
      customerMetalCredit: null,
      exchange: null,
      financialYear: financialyear,
      ledgerDetailsDomainList: null,
      prodAdvRcpt: productOrderReceiptData,
      productOrderItems: productOrderItemList,
    });
    const response = createProductOrder(productOrderDetails)
      response.then(
        () => {
        toast.success("Order Booked Successfully!!!", { duration: 2500, position: "top-right", style: { background: "#1a1a1a", color: "#fff", borderRadius: 10, fontSize: 13 } });
        setIsOrderLoading(false);
      }
    )
      .catch(() => {
        toast.error("Failed to Book Your Order. Please try again.", { position: "top-right" });
        setIsOrderLoading(false);
      });
  };
  
  // const history = useNavigate();
  const location = useLocation();
  const { dispatch } = useCartContext();

  const getTaxData = () => {
    const filterData = {
      branch: getBranchId(),
      active: 1,
      module: "Sale",
    };
    const respData = getAllTax(filterData);
    const taxList = [];
    const sgTax = [];
    respData.then((data) => {
      data.response.forEach((item) => {
        if (item.chargeName === "CGST") {
          const taxValue = `${item.chargeName}-${item.chargeValue}`;
          taxList.push({
            value: item.id,
            label: taxValue,
            name: item.chargeName,
            percent: item.chargeValue,
          });
        } 
        if (item.chargeName === "SGST") {
          const taxValue = `${item.chargeName}-${item.chargeValue}`;
          sgTax.push({
            value: item.id,
            label: taxValue,
            name: item.chargeName,
            percent: item.chargeValue,
          });
        }  
      });
      setSelectedTax(taxList);
      setSelectedSGTax(sgTax);
    });
  };

    useEffect(() => {
      Promise.all([
        getPaymentData(),
        getFinacialYearData(),
        getProductRate(),
        getProductOrderStatus(),
        getmetalStandardList(),
        getTaxData()
       ]) 
       .then(() => {
      setLoader(false); 
      setDetails([]);
      setImg([]);
      getProductIdParsing();
      getBanner(); 
      })
      .catch((err) => console.error(err));
      //eslint-disable-next-line
    }, [location.pathname, location.state]);

  const getProductIdParsing = () => {
    let pid = "";
    if (!location.state) { const p = location.pathname.split("/"); pid = p[2]; }
    else { pid = location.state.categoryItem.productId ? location.state.categoryItem.productId :location.state.categoryItem.id; }
    setProductId(pid);
    getRateApi(pid);
    likeCountDetails(pid);
    wishCountDetails(pid);
    customerLikeWishState(pid);
  };

  const customerLikeWishState = (pid) => {
    const cid = getCustomerId();
    if (cid !== "onlinepayment" && cid !== "" && cid !== null && cid !== undefined) {
      const likeWishFilter = `customerId=${cid}&productId=${pid}`;
      productLikeCount(likeWishFilter).then((data) => {
        setLiked(data.response > 0);
      });
      productWishCount(likeWishFilter).then((item) => {
        setWished(item.response.length > 0);
      });
    } else {
      setLiked(false);
      setWished(false);
    }
  };

  const getBanner = () => {
    configImages?.E_COMMERCE_BANNERS?.forEach((d) => { if (d.key === "productDetails") setBanner(d.value); });
  };

  const getRateApi = async (pid) => {
    let allOtherCharges = [], stoneChargeList = [], secMetalDetails = [];
    const currentDate = moment().format(YEAR_WISE_FORMAT);
    const filter = { branch: getBranchId(), beforeCreatedAt: filterFormatToDate(currentDate), id: pid };
    dispatch({ type: "DAYCLOSED", payload: filterFormatToDate(currentDate) });

    await getProduct(10, filter).then((data) => {
      const productResponse = data.response.content[0];
      if (productResponse !== null && productResponse !== undefined && productResponse !== "" && productResponse !== "-") {
        const img = productResponse.images;
        const productImg = img.split("@#@").filter((i) => i !== "");
        setImg(productImg);
        setCurrentImg(productImg[0]);
      } else setCurrentImg(Noimg);

      setSpec(data.response.prodSpecMappingList ?? "");
      const otherChargeJSON = data.response.content?.length > 0 ? JSON.parse(data.response.content[0]?.otherCharges) : [];
      const secMetalJSON = data.response.content?.length > 0 ? JSON.parse(data.response.content[0]?.secMetalDetails) : [];
      secMetalJSON.forEach((item) => secMetalDetails.push(item));

      const datas = otherChargeJSON.filter((item) =>
        ["stonecharge","handlingcharge","stampingcharge","additionalcharge","freightCharges"].includes(item.remarks)
      );
      allOtherCharges = datas;
      setAdditionalCharge(allOtherCharges);

      otherChargeJSON.forEach((item) => {
        if ({}.hasOwnProperty.call(item, "stone") && item.stone.length > 0) stoneChargeList = item.stone;
      });

      let Certificate;
      // eslint-disable-next-line
      productResponse && JSON.parse(productResponse.otherCharges).map((value) => { if (value.stone?.length > 0) Certificate = value.stone[0].certificatenumber; });
      const weight = productResponse && JSON.parse(productResponse.weight);
      setDetails({ ...productResponse, Certificate, weight });
      setLoader(true);
      setOtherCharge(stoneChargeList);
      setSecMetalDetail(secMetalDetails);
    });
  };

  const likeCountDetails = async (id) => {
    try { const d = await likeCount(id); setLikeCount(d.response > 0 ? d.response : 0); } catch { setLikeCount(0); }
  };

  const wishCountDetails = async (id) => {
    try { const d = await wishCount(id); setWishCount(d.response > 0 ? d.response : 0); } catch { setWishCount(0); }
  };


  // const addToCart = (productCode) => {
  //   const productData = JSON.parse(getAddToCart() !== undefined ? getAddToCart() : "[]");
  //   if (productData.length < 3) {
  //     if (!productData.some((i) => i.productCode === productCode)) {
  //       productData.push(Details);
  //       setAddToCart(JSON.stringify(productData));
  //       dispatch({ type: "ADD", payload: JSON.parse(getAddToCart()) });
  //       toast.success("Added to cart!", { duration: 2000, position: "top-right", style: { background: "#1a1a1a", color: "#fff", borderRadius: 10, fontSize: 13 } });
  //     } else toast.error("Already in cart!", { duration: 2000, position: "top-right" });
  //   } else toast.error("Cart limit reached (max 3 items)", { duration: 2000, position: "top-right" });
  // };

  // const buynow = (productCode) => {
  //   let existingCart = JSON.parse(getAddToCart() || "[]");
  //   const alreadyInCart = existingCart.some(
  //     (item) => item.productCode === productCode
  //   );
  //   if (!alreadyInCart) {
  //     existingCart.push(Details);
  //   }
  //   setAddToCart(JSON.stringify(existingCart));
  //   dispatch({ type: "ADD", payload: existingCart });
  //   const totalAmount = existingCart.reduce(
  //     (acc, item) => acc + (item.total || 0),
  //     0
  //   );
  //   if (getCustomerId()) {
  //     history("/CheckoutPage", {
  //       state: {
  //         viewCart: existingCart,
  //         total: Math.trunc(totalAmount),
  //       },
  //     });
  //   } else {
  //     dispatch({ type: "MODAL", payload: "login" });
  //   }
  // };

  const thumb = (index) => setCurrentImg(Img[index]);

  const handleLike = async () => {
    const cid = getCustomerId();
    if (cid === "onlinepayment" || cid === "" || cid === null || cid === undefined) {
      dispatch({ type: "MODAL", payload: "login" });
      return;
    }
    try {
      const filter = `customerId=${cid}&productId=${productId}`;
      if (liked) {
        setLiked(false);
        setLikeCount((prev) => prev - 1);
        await deleteCustomerLike(filter);
      } else {
        setLiked(true);
        setLikeCount((prev) => prev + 1);
        await createCustomerLike(`${filter}&remark=liked`);
      }
    } catch (err) {
      console.log(err);
      setLiked((prev) => !prev);
      setLikeCount((prev) => (liked ? prev + 1 : prev - 1));
    }
  };

  const handleWish = async () => {
    const cid = getCustomerId();
    if (cid === "onlinepayment" || cid === "" || cid === null || cid === undefined) {
      dispatch({ type: "MODAL", payload: "login" });
      return;
    }
    try {
      const filter = `customerId=${cid}&productId=${productId}`;
      if (wished) {
        setWished(false);
        setWishCount((prev) => prev - 1);
        await deleteCustomerWish(filter);
      } else {
        setWished(true);
        setWishCount((prev) => prev + 1);
        await createCustomerWish(`${filter}&remark=liked`);
      }
    } catch (err) {
      console.log(err);
      setWished((prev) => !prev);
      setWishCount((prev) => (wished ? prev + 1 : prev - 1));
    }
  };

  const totalPrice = (Details.total && Details.pieceRate > 0) ? Details.total.toFixed(2).toLocaleString("en-IN") : (Details.total && Details.pieceRate <= 0) ? Math.trunc(Details.total).toLocaleString("en-IN") : 0

  return (
    <StyledDiv>
      <Toaster position="top-right" />

      {/* Banner */}
      {/* {banner?.length > 0 ? (
        <img src={banner} alt="Product Details" className="w-100" style={{ maxHeight: 220, objectFit: "cover" }} />
      ) : null} */}

      {/* ── Breadcrumb ── */}
      {/* <div style={{ background: "var(--surface-cream)", borderBottom: `1px solid ${"var(--gold-200)"}` }}> */}
        <div className="container">
          <nav style={{ display: "flex", alignItems: "center", gap: 8, paddingTop: "20px", fontSize: 10 }}>
                    <Link
                      to="/"
                      tw="mx-3 no-underline"
                      style={{
                        color: "#9b9b9b",
                        textDecoration: "none",
                        fontWeight: 400,
                      }}
                    >
                      HOME
                    </Link>
                    <span style={{ color: "#9b9b9b"}}>{">"}</span>
                    <Link
                      to="/ProductList"
                      tw="mx-3 no-underline"
                      style={{
                        color: "#9b9b9b",
                        textDecoration: "none",
                        fontWeight: 400,
                      }}
                    >
                      {Details.typeName || Details.category || "PRODUCT"}
                    </Link>
                    <span style={{ color: "#9b9b9b"}}>{">"}</span>
                    <span
                      tw="ml-3 text-custom-100 capitalize tracking-wide"
                      style={{
                        color: '#9b9b9b',
                        fontWeight: 400,
                        textTransform: "uppercase",
                        fontSize: "10px",
                      }}
                    >
                      {Details.productName || "PRODUCT"}
            </span>
          </nav>
        </div>
      {/* </div> */}

      {/* ── Main content ── */}
      <section style={{ padding: "20px", background: "#ffffff" }}>
        <div className="container-lg">
          <div className="row g-5">
            {isLoader ? (
              <>
                <div className="col-md-5">
                  <div style={{ position: "sticky", top: 88 }}>
                    {/* Status badge */}
                    <div style={{ marginBottom: 10, display: "flex", gap: 8, alignItems: "center" }}>
                      {Details.status === "Sale" ? (
                        <span style={{
                          display: "inline-flex", alignItems: "center", gap: 5,
                          padding: "4px 12px", borderRadius: "var(--radius-pill)",
                          background: "#e6f9f0", border: "1px solid #86efad",
                          fontSize: 11, fontWeight: 700, color: "#166534",
                        }}>
                          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#16a34a" }} />
                          In Stock
                        </span>
                      ) : (
                        <span style={{
                          display: "inline-flex", alignItems: "center", gap: 5,
                          padding: "4px 12px", borderRadius: "var(--radius-pill)",
                          background: "#fef2f2", border: "1px solid #fca5a5",
                          fontSize: 11, fontWeight: 700, color: "#991b1b",
                        }}>
                          <span style={{ width: 6, height: 6, borderRadius: "50%", background: "#dc2626" }} />
                          Out of Stock
                        </span>
                      )}
                    </div>

                    {/* Main image */}
                    <div style={{
                      borderRadius: "var(--radius-lg)", overflow: "hidden",
                      border: `1px solid ${"var(--gold-200)"}`,
                      background: "var(--surface-warm)",
                      boxShadow: "var(--shadow-sm)",
                    }}>
                    <Magnifier imgSrc={currentImg} imgWidth="100%" imgHeight="100%" magnifierRadius={120} />
                    </div>

                  {Img.length > 1 && (
                    <div style={{ marginTop: 12 }}>
                      <Carousel
                        emulateTouch swipeable interval={5000} transitionTime={600}
                        onClickThumb={(idx) => thumb(idx)}
                        showStatus={false} showIndicators={false}
                        className="role"
                      >
                        {Img.map((src, i) => (
                          <div key={i} style={{ cursor: "pointer" }}>
                            <img alt={`view-${i}`} src={src} style={{ height: 80, objectFit: "cover" }} />
                          </div>
                        ))}
                      </Carousel>
                    </div>
                  )}
                  </div>
                </div>

                <div className="col-md-7">
                  {/* ── Product name & social counts ── */}
                  <div style={{ marginBottom: 18 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 12, marginBottom: 10 }}>
                      <h1 style={{
                        fontFamily: "Cormorant Garamond, Georgia, serif",
                        fontSize: "clamp(26px, 3.5vw, 38px)",
                        fontWeight: 600, color: "var(--red-900)",
                        margin: 0, lineHeight: 1.15, flex: 1,
                      }}>
                        {Details.productName}
                      </h1>
                    </div>
                    <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                      <StatChip
                        icon={<svg width="13" height="13" viewBox="0 0 24 24" fill={wished ? "#e11d48" : "none"} stroke={wished ? "#e11d48" : "currentColor"} strokeWidth="2"><path d="M20.84 4.61a5.5 5.5 0 00-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 00-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 000-7.78z" /></svg>}
                        onClick={handleWish} count={WishCount} label="Wish"
                      />
                      <StatChip
                        icon={<svg width="13" height="13" viewBox="0 0 24 24" fill={liked ? "#f4d07b" : "none"} stroke={liked ? "#f4d07b" : "currentColor"} strokeWidth="2"><path d="M14 9V5a3 3 0 00-3-3l-4 9v11h11.28a2 2 0 002-1.7l1.38-9a2 2 0 00-2-2.3H14z" /><path d="M7 22H4a2 2 0 01-2-2v-7a2 2 0 012-2h3" /></svg>}
                        onClick={handleLike} count={LikeCount} label="Like"
                      />
                    </div>
                  </div>

                  {/* ── Info rows ── */}
                  <div style={{
                    background: "var(--surface-warm)", borderRadius: "var(--radius-md)",
                    border: `1px solid ${"var(--gold-200)"}`, padding: "4px 16px",
                    marginBottom: 20,
                  }}>
                    <InfoRow label="Product Code" value={
                      <span style={{ fontFamily: "monospace", fontSize: 13, background: "var(--red-100)", padding: "2px 8px", borderRadius: 6 }}>
                        {Details.productCode}
                      </span>
                    } />
                    <InfoRow
                      label="Product Type"
                      value={Details.productTypeName}
                      purity={ <Pill>{`(${Details.goldPurity !== undefined ? Details.goldPurity : ''}) - ₹${Math.trunc(Details.todayRate)}`}</Pill>}
                    />
                    {Details.brand && <InfoRow label="Brand" value={Details.brand} />}
                    {Details.branchName && (
                      <InfoRow label="Available at" value={
                        <span style={{ display: "flex", alignItems: "center", gap: 5, color: "var(--red-700)" }}>
                          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke={"var(--gold-400)"} strokeWidth="2.5"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z" /><circle cx="12" cy="10" r="3" /></svg>
                          {Details.branchName}
                        </span>
                      } />
                    )}
                  </div>

                  {/* ── Price card ── */}
                  <div style={{ marginBottom: 20 }}>
                    <SectionLabel>Total Price</SectionLabel>
                    <div style={{
                      fontFamily: "'InterSemiBold','NotoSansDevanagariSemiBold','Helvetica Neue',Helvetica,Arial,sans-serif",
                      fontSize: "clamp(30px, 2vw, 50px)",
                      fontWeight: 500, color: "var(--red-900)"
                    }}>
                      ₹{totalPrice}
                    </div>
                    <p style={{ fontSize: 11, color: "var(--red-400)", margin: "8px 0 0", fontStyle: "italic" }}>
                      (*Inclusive of all taxes(3%))
                    </p>
                  </div>

                  {/* ── Weight details ── */}
                  {(parseFloat(Details.weight?.grossWeight) !== 0 || parseFloat(Details.weight?.lessWeight) !==0 ||  parseFloat(Details.weight?.netWeight) !== 0) &&
                  <div style={{ marginBottom: 20 }}>
                    <SectionLabel>Weight Details</SectionLabel>
                    <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 15 }}>
                      <WeightCard label="Gross Wt" value={Details.weight?.grossWeight} />
                      <WeightCard label="Less Wt" value={Details.weight?.lessWeight} />
                      <WeightCard label="Net Wt" value={Details.weight?.netWeight} />
                    </div>
                  </div>
                  }
                  {/* ── Wastage + Charges ── */}
                  {((Details.wastageValue !==0 && Details.wastageValue !== null) || (Details.mcValue !== 0 && Details.mcValue !== null)) && (
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 20 }}>
                      <div style={{ padding: "14px 18px", background: "var(--gold-50)", border: "1px solid var(--gold-100)", borderRadius: 10 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: "#c9a34d", marginBottom: 6 }}>Wastage</div>
                        <div style={{ fontSize: 15, fontWeight: 400, color:  "#6b5330"}}>
                          {Details.wastageValue}{Details.wastageType === "percentage" ? "%" : Details.wastageType === "pieces" ? " pcs" : Details.wastageType === "rs" ? "gm" : Details.wastageType === "mg" ? " per gm" : ""}
                        </div>
                      </div>
                      <div style={{ padding: "14px 18px", background: "var(--gold-50)", border: "1px solid var(--gold-100)", borderRadius: 10 }}>
                        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: "#c9a34d", marginBottom: 6 }}>Making Charge</div>
                        <div style={{ fontSize: 15, fontWeight: 400, color: "#6b5330" }}>{Details.mcValue}{Details.mcType === "percentage" ? "%" : Details.mcType ==="pieces" ? " pcs" : Details.mcType === "rs" ? "Rs" : Details.mcType ==="mg" ? " per gm" : ""}</div>
                      </div>
                    </div>
                  )}

                  {/* ── Description ── */}
                  {Details.description && Details.description !== "-" && Details.description !== "" && (
                    <div style={{ marginBottom: 20 }}>
                      <SectionLabel>Description</SectionLabel>
                      <p style={{ fontSize: 14, lineHeight: 1.85, color: "var(--red-700)", margin: 0 }}>
                        {Details.description}
                      </p>
                    </div>
                  )}

                  {/* ── Certificate ── */}
                  {Details.Certificate > 0 && (
                    <div style={{
                      display: "flex", alignItems: "center", gap: 10,
                      padding: "10px 16px", borderRadius: "var(--radius-md)",
                      background: "#f8ebff", border: "1px solid #f6d891",
                      marginBottom: 16, fontSize: 13, color: "#926a0e",
                    }}>
                      <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#af7f0e" strokeWidth="2">
                        <circle cx="12" cy="8" r="6" />
                        <path d="M9 12l2 2 4-4" />
                        <path d="M8 14v7l4-2 4 2v-7" />
                      </svg>
                      Certificate No: <strong style={{ color: "#78580f" }}>{Details.Certificate}</strong>
                    </div>
                  )}

                  {/* ── Accordions ── */}
                  {additionalCharge?.length > 0 && (
                    <AccordionPanel title="Additional Charges" open={isActive} onToggle={() => setIsActive(!isActive)}>
                      <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 0, borderRadius: "var(--radius-md)", overflow: "hidden", border: `1px solid ${"var(--gold-200)"}` }}>
                        {["Charge Type", "Piece", "Charge"].map((h) => (
                          <div key={h} style={{ padding: "9px 14px", background: "var(--surface-warm)", fontSize: 10, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: "var(--red-400)", borderBottom: `1px solid ${"var(--gold-200)"}` }}>{h}</div>
                        ))}
                        <div style={{ padding: "10px 14px", fontSize: 14, color: "var(--red-900)" }}>{additionalCharge[0]?.type || "—"}</div>
                        <div style={{ padding: "10px 14px", fontSize: 14, color: "var(--red-900)" }}>{additionalCharge[0]?.piece || "—"}</div>
                        <div style={{ padding: "10px 14px", fontSize: 14, color: "var(--red-900)" }}>{additionalCharge[0]?.charge || "—"}</div>
                      </div>
                    </AccordionPanel>
                  )}

                  {secMetalDetail?.length > 0 && (
                    <AccordionPanel title="Secondary Metal" open={isActiveToggle} onToggle={() => setIsActiveToggle(!isActiveToggle)}>
                      <div className="row g-3">
                        {[["Metal Type", secMetalDetail[0]?.productTypeName], ["Purity", secMetalDetail[0]?.purityName], ["Hallmarked", secMetalDetail[0]?.standardName], ["Piece", secMetalDetail[0]?.piece], ["Net Weight", secMetalDetail[0]?.weight?.netWeight]].map(([label, value]) => value ? (
                          <div key={label} className="col-6">
                            <div style={{ fontSize: 10, fontWeight: 700, color: "var(--red-400)", letterSpacing: ".07em", textTransform: "uppercase", marginBottom: 3 }}>{label}</div>
                            <div style={{ fontSize: 14, fontWeight: 500, color: "var(--red-900)" }}>{value}</div>
                          </div>
                        ) : null)}
                      </div>
                    </AccordionPanel>
                  )}

                  {/* ── Stone details ── */}
                  {otherCharge?.length > 0 && (
                    <div style={{ marginBottom: 20, marginTop: 8 }}>
                      <SectionLabel>Stone Details</SectionLabel>
                      <div style={{ border: `1px solid ${"var(--gold-200)"}`, borderRadius: "var(--radius-md)", overflow: "hidden" }}>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)", background: "var(--surface-warm)" }}>
                          {["Material", "Pieces", "Type", "Weight", "Cost"].map((h) => <div key={h} style={{ padding: "10px 14px", fontSize: 10, fontWeight: 700, letterSpacing: ".08em", textTransform: "uppercase", color: "var(--red-400)", borderBottom: `1px solid ${"var(--gold-200)"}` }}>{h}</div>)}
                        </div>
                        {otherCharge.map((item, i) => (
                          <div key={i} style={{ display: "grid", gridTemplateColumns: "repeat(5,1fr)" }}>
                            <div style={tableCellStyle}>{item.dataName}</div>
                            <div style={tableCellStyle}>{item.pieces}</div>
                            <div style={tableCellStyle}>{item.typeName}</div>
                            <div style={tableCellStyle}>{item.grm}</div>
                            <div style={tableCellStyle}>{item.totalValue}</div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  {/* Spec + Price details */}
                  <div className="row g-3" style={{ marginBottom: 28 }}>
                    {Spec.length > 0 && (
                      <div className="col-md-4">
                        <SectionLabel>Specifications</SectionLabel>
                        {Spec.map((s, i) => (
                          <div key={i} style={{
                            display: "flex", justifyContent: "space-between",
                            padding: "8px 0", borderBottom: `1px solid ${"var(--gold-100)"}`, fontSize: 13,
                          }}>
                            <span style={{ color: "var(--red-500)" }}>{s.specificationName.split("_")[0]}</span>
                            <span style={{ color: "var(--red-900)", fontWeight: 500 }}>
                              {s.specificationValue !== "NA" ? s.specificationValue : "—"}
                            </span>
                          </div>
                        ))}
                      </div>
                    )}
                    {Details.basePrice !==undefined ? (
                    <div className={Spec.length > 0 ? "col-md-8" : "col-md-12"}>
                      <ProductPriceDetails Details={Details} secMetalDetail={secMetalDetail} stoneDetail={otherCharge} />
                    </div>
                    ) : null}
                  </div>

                  {/* ── Action buttons ── */}
                  <div style={{
                    display: "grid",
                    gridTemplateColumns: "1fr",
                    gap: 12, paddingTop: 4,
                  }}>
                    {/* Buy Now and Add to Bag commented out — replaced by Book Enquiry */}
                    {/* {Details.status === "Sale" && (
                      <>
                        <ActionBtn
                          label="Add to Bag"
                          variant="secondary"
                          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/><line x1="12" y1="15" x2="12" y2="19"/><line x1="10" y1="17" x2="14" y2="17"/></svg>}
                          onClick={() => addToCart(Details.productCode)}
                        />
                        <ActionBtn
                          label="Buy Now"
                          variant="primary"
                          icon={<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M5 12h14"/><path d="M12 5l7 7-7 7"/></svg>}
                          onClick={() => buynow(Details.productCode)}
                        />
                      </>
                    )}
                    {Details.status !== "Sale" && (
                      <ActionBtn
                        label="Out of Stock"
                        variant="ghost"
                        icon={
                          <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" />
                          </svg>
                        }
                      />
                    )} */}
                    {Details.status !== "Sale" ? (
                    <ActionBtn
                      label="Book Your Order"
                      variant="primary"
                      disabled={isOrderLoading}
                      icon={
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                          <line x1="16" y1="2" x2="16" y2="6"/>
                          <line x1="8" y1="2" x2="8" y2="6"/>
                          <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                      }
                      onClick={handleBookProductOrder}
                    />
                     ) : (
                      <ActionBtn
                      label="Book Enquiry"
                      variant="primary"
                      disabled={isEnquiryLoading}
                      icon={
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                          <line x1="16" y1="2" x2="16" y2="6"/>
                          <line x1="8" y1="2" x2="8" y2="6"/>
                          <line x1="3" y1="10" x2="21" y2="10"/>
                        </svg>
                      }
                      onClick={handleBookEnquiry}
                    />
                    )}
                  </div>
                </div>
              </>
            ) : (
              // Skeleton loader
              <>
                <div className="col-md-5"><Skeleton style={{ height: 480, borderRadius: 16 }} /></div>
                <div className="col-md-7">
                  <Skeleton height={36} width="60%" style={{ marginBottom: 16, borderRadius: 8 }} />
                  {[1, 2, 3].map((i) => <Skeleton key={i} height={40} style={{ marginBottom: 8, borderRadius: 8 }} />)}
                  <Skeleton height={120} style={{ borderRadius: 14, marginBottom: 16 }} />
                  <Skeleton height={60} style={{ borderRadius: 10, marginBottom: 16 }} />
                  <div style={{ display: "grid", gridTemplateColumns: "repeat(3,1fr)", gap: 10 }}>
                    {[1, 2, 3].map((i) => <Skeleton key={i} height={46} style={{ borderRadius: 10 }} />)}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>

      {isLoader && <RelatedProduct Details={Details} />}

      {/* <div>
        <ProductType />
      </div> */}
    </StyledDiv>
  );
};